export default "__VITE_ASSET__ClL$4sbz__"